import { Check, MapPin } from "lucide-react";
import { Button } from "./ui/button";

const HERO_VIDEO = "/assets/uba-fondo.mp4";

export const CountryHero = ({ market }) => {
  return (
    <section id="top" className="relative overflow-hidden" data-testid="country-hero">
      <video
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover"
        data-testid="country-hero-video"
      >
        <source src={HERO_VIDEO} type="video/mp4" />
      </video>
      <div className="absolute inset-0 bg-gradient-to-r from-[#0d2b52] via-[#0d2b52]/95 to-[#0d2b52]/75" aria-hidden="true" />

      <div className="relative mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:py-32 lg:px-8">
        <div className="max-w-3xl">
          <div
            className="inline-flex items-center gap-2 border border-white/20 bg-white/10 px-3 py-1.5 backdrop-blur-sm"
            data-testid="country-badge"
          >
            <MapPin className="h-3.5 w-3.5 text-[#2f9be8]" />
            <span className="font-display text-xs font-bold uppercase tracking-[0.2em] text-white">
              {market.badge}
            </span>
          </div>

          <h1
            className="font-display mt-6 text-4xl font-bold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl"
            data-testid="country-title"
          >
            {market.title}
            <span className="block text-[#2f9be8]">{market.titleAccent}</span>
          </h1>

          <div
            className="mt-6 inline-block bg-white px-5 py-2.5"
            data-testid="country-price"
          >
            <span className="font-display text-2xl font-bold tracking-tight text-[#0d2b52] sm:text-3xl">
              {market.heroPrice}
            </span>
          </div>

          <p
            className="mt-6 max-w-xl text-base leading-relaxed text-[#e2e8f0] sm:text-lg"
            data-testid="country-subtitle"
          >
            {market.subtitle}
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-4">
            <Button
              asChild
              size="lg"
              className="rounded-none bg-[#1d6fd1] px-8 font-display text-base font-bold text-white transition-colors hover:bg-[#2f9be8]"
              data-testid="country-cta-primary"
            >
              <a href="#contact">{market.ctaPrimary}</a>
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              className="rounded-none border-white bg-transparent px-8 font-display text-base font-semibold text-white hover:bg-white/10 hover:text-white"
              data-testid="country-cta-secondary"
            >
              <a href="#servicii">{market.ctaSecondary}</a>
            </Button>
          </div>

          <ul className="mt-10 space-y-3" data-testid="country-points">
            {market.points.map((point, i) => (
              <li
                key={i}
                className="flex items-start gap-3 text-sm font-semibold text-white sm:text-base"
                data-testid={`country-point-${i}`}
              >
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center bg-[#1d6fd1]">
                  <Check className="h-3.5 w-3.5 text-white" strokeWidth={3} />
                </span>
                {point}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
